<template>
    <section class="categories-listing" :style="styles" :class="{ loading: loading }">
        <transition name="fade" appear>
            <div class="container" v-if="categories && categories.length">
                <h5>{{ title }}</h5>
                <div class="row">
                    <div class="column"
                         v-for="(category, key) in categories"
                         :key="key"
                         v-for-callback="{ key: key, array: categories, callback: loading = false }"
                    >
                        <a :href="category.detail_url"
                           class="category js-ga-event"
                           :data-page-area="dataPageArea"
                           data-type="item"
                           data-name="category-name"
                           :data-text="category.name"
                           data-action="href"
                           :data-destination-url="category.detail_url"
                        >
                            <figure>
                               <template v-if="category.image_url">
                                   <img :src="category.image_url"
                                        loading="lazy"
                                        :alt="category.name"
                                   >
                               </template>
                                <template v-else>
                                    <img :src="constants.defaultImage"
                                         loading="lazy"
                                         :alt="category.name"
                                    >
                                </template>
                            </figure>
                            <p>
                                {{ category.name }}
                            </p>
                        </a>
                    </div>
                </div>
            </div>
        </transition>

        <template v-if="loading">
            <ComponentLoader />
        </template>
    </section>
</template>

<script>
import { onMounted, ref, inject } from 'vue'
import axios from 'axios'

import ComponentLoader from '../globals/ComponentLoader'

export default {

    props: [
        'title',
        'catIds',
        'styles',
        'dataPageArea'
    ],

    components: {
        ComponentLoader
    },

    setup(props) {

        const constants  = inject('constants')
        const loading    = ref(true)
        const categories = ref(null)

        onMounted( () => fetchCategories())

        function fetchCategories() {
            axios.post('/api/get-categories', {
                catIds: props.catIds,
                currentLocale: document.querySelector("body").getAttribute("data-language"),
            }).then( response => {
                if ( response.status === 200 )
                    categories.value = response.data.categories
                else
                    flash('Niečo sa pokazilo', 'danger')
            }).catch( error => flash(error.message, 'danger'))
        }

        return {
            loading,
            categories,
            constants
        }
    }
}
</script>
